const riskLevels = [
  { level: 'Critical', color: '#EF4444' },
  { level: 'Medium', color: '#F59E0B' },
  { level: 'Low', color: '#399432' },
];

const zoneAssetConfig = {
  'finishing-zone': {
    names: [
      'CNC Lathe Alpha',
      'CNC Lathe Beta',
      'Surface Grinder SG-01',
      'Polishing Station PS-04',
      'Deburring Machine DB-02',
      'Coating Booth CB-06',
      'Inspection Station IS-03',
      'Honing Machine HM-07',
    ],
    issues: [
      'Unusual vibration detected',
      'Temperature anomaly detected',
      'Bearing wear detected',
      'Oil pressure fluctuation',
      'Motor current spike detected',
      'Alignment issue detected',
    ],
  },
  'assembly-zone': {
    names: [
      'Welding Robot W-22',
      'Welding Robot W-31',
      'Torque Station T-05',
      'Rivet Press RP-12',
      'Assembly Conveyor AC-03',
      'Pick & Place PP-08',
      'Screw Driver SD-14',
      'Press Fit PF-09',
    ],
    issues: [
      'Calibration drift detected',
      'Torque variance detected',
      'Cycle time increasing',
      'Pneumatic pressure drop',
      'Servo motor overheating',
      'Belt tension anomaly',
    ],
  },
  'packaging-zone': {
    names: [
      'Heat Sealer HS-08',
      'Label Printer LP-02',
      'Palletizer P-01',
      'Shrink Wrapper SW-05',
      'Carton Former CF-11',
      'Tape Dispenser TD-03',
      'Stretch Wrapper STW-06',
      'Case Packer CP-09',
    ],
    issues: [
      'Sealing temperature unstable',
      'Label misalignment detected',
      'Hydraulic pressure decline',
      'Film tension irregular',
      'Glue nozzle clogging',
      'Motor vibration increasing',
    ],
  },
};

const assetImages = [
  '/images/cnc-lathe-1.png',
  '/images/cnc-lathe-2.png',
  '/images/cnc-lathe-3.png',
  '/images/cnc-lathe-4.png',
];

const supervisors = ['John Smith', 'Sarah Johnson', 'Mike Chen', 'Lisa Rodriguez'];
const technicians = ['Alex Brown', 'Emma Wilson', 'David Lee', 'Maria Garcia', 'Sofia Anderson'];

const zoneLocationMap = {
  'finishing-zone': 'Workspace East > Zone 48 > Finishing Zone',
  'assembly-zone': 'Workspace East > Zone 22 > Assembly Zone',
  'packaging-zone': 'Workspace East > Zone 15 > Packaging Zone',
};

const riskPriorityMap = { Critical: 'High', Medium: 'Moderate', Low: 'Low' };
const riskHealthMap = { Critical: 55, Medium: 72, Low: 88 };
const riskFailureProbMap = { Critical: 85, Medium: 45, Low: 15 };
const riskTimeframeMap = { Critical: 'within 7 days', Medium: 'within 1 month', Low: 'within 3 months' };
const riskSeverityMap = {
  Critical: { severity: 'Emergency Maintenance', description: 'Immediate attention required to prevent failure' },
  Medium: { severity: 'Scheduled Maintenance', description: 'Schedule maintenance during next downtime window' },
  Low: { severity: 'Preventive Maintenance', description: 'Monitor and plan routine inspection' },
};

const makes = ['CSB Industries', 'FluidTech Inc', 'PowerDrive Corp', 'HydroMax Ltd'];
const types = ['Pump', 'Motor', 'Hydraulic', 'CNC', 'Conveyor', 'Robotic'];

// ─── Hardcoded primary assets (aligned with dashboardMockData & healthCheckMockData) ───

const primaryAssetsByZone = {
  'finishing-zone': [
    {
      id: 1,
      name: 'CNC Lathe',
      fullName: 'CNC Lathe',
      assetId: 'A231',
      image: '/images/cnc-lathe-4.png',
      issue: 'Emergency maintenance recommended',
      status: 'Online',
      riskLevel: 'Critical',
      riskColor: '#EF4444',
      priority: 'High',
      location: {
        full: 'Workspace East > Zone 48 > Finishing Zone',
        workspace: 'Workspace East',
        zone: 'Zone 48',
        area: 'Finishing Zone',
      },
      healthScore: 52,
      rul: { label: 'Remaining Useful Life', value: '1 Year 6 Months' },
      rulColor: '#EF4444',
      failuresLastMonth: 3,
      lastChecked: '2 mins ago',
      supervisor: 'John Smith',
      technician: 'Lisa Cruise',
      confidence: 80,
      rulPercentage: 68,
      zone: 'finishing-zone',
      failurePrediction: '85% failure probability',
      failureProbability: 85,
      failureTimeframe: 'within 7 days',
      workOrders: { label: 'Open Work Orders', value: 5 },
      workOrderId: 'WO-1334',
      nextService: { label: 'Next Scheduled Service', value: '15 Mar 2026' },
      model: 'RFS465465',
      type: 'Pump',
      make: 'CSB Industries',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Emergency Maintenance', description: 'Replace bearing immediately to prevent failure' },
      alert: { type: 'error', message: 'Emergency maintenance recommended', confidence: '80%' },
      sensors: {
        temperature: { label: 'Temperature', value: 95, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:32 AM' },
        vibration: { label: 'Vibration', value: 6.5, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:32 AM' },
        pressure: { label: 'Pressure', value: 2.8, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:32 AM' },
      },
    },
    {
      id: 2,
      name: 'Hydraulic Pump',
      fullName: 'Hydraulic Pump',
      assetId: 'A232',
      image: '/images/cnc-lathe-2.png',
      issue: 'Estimated failure in 1 month',
      status: 'Online',
      riskLevel: 'Medium',
      riskColor: '#F59E0B',
      priority: 'Moderate',
      location: {
        full: 'Workspace East > Zone 48 > Finishing Zone',
        workspace: 'Workspace East',
        zone: 'Zone 48',
        area: 'Finishing Zone',
      },
      healthScore: 68,
      rul: { label: 'Remaining Useful Life', value: '2 Years 3 Months' },
      rulColor: '#F59E0B',
      failuresLastMonth: 1,
      lastChecked: '5 mins ago',
      supervisor: 'Sarah Johnson',
      technician: 'Alex Brown',
      confidence: 90,
      rulPercentage: 71,
      zone: 'finishing-zone',
      failurePrediction: '45% failure probability',
      failureProbability: 45,
      failureTimeframe: 'within 30 days',
      workOrders: { label: 'Open Work Orders', value: 2 },
      workOrderId: 'WO-1335',
      nextService: { label: 'Next Scheduled Service', value: '12 Apr 2026' },
      model: 'HPX789456',
      type: 'Hydraulic System',
      make: 'Bosch Rexroth',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Scheduled Maintenance', description: 'Schedule oil change and filter replacement within 2 weeks' },
      alert: { type: 'warning', message: 'Estimated failure in 1 month', confidence: '90%' },
      sensors: {
        temperature: { label: 'Temperature', value: 68, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:28 AM' },
        vibration: { label: 'Vibration', value: 4.2, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:28 AM' },
        pressure: { label: 'Pressure', value: 2.3, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:28 AM' },
      },
    },
    {
      id: 3,
      name: 'Motor Drive',
      fullName: 'Motor Drive',
      assetId: 'A233',
      image: '/images/cnc-lathe-1.png',
      issue: 'Estimated failure in 3 months',
      status: 'Online',
      riskLevel: 'Low',
      riskColor: '#399432',
      priority: 'Low',
      location: {
        full: 'Workspace East > Zone 48 > Finishing Zone',
        workspace: 'Workspace East',
        zone: 'Zone 48',
        area: 'Finishing Zone',
      },
      healthScore: 73,
      rul: { label: 'Remaining Useful Life', value: '1 Year 10 Months' },
      rulColor: '#399432',
      failuresLastMonth: 0,
      lastChecked: '8 mins ago',
      supervisor: 'Mike Chen',
      technician: 'David Lee',
      confidence: 85,
      rulPercentage: 73,
      zone: 'finishing-zone',
      failurePrediction: '25% failure probability',
      failureProbability: 25,
      failureTimeframe: 'within 90 days',
      workOrders: { label: 'Open Work Orders', value: 2 },
      workOrderId: 'WO-1336',
      nextService: { label: 'Next Scheduled Service', value: '20 Apr 2026' },
      model: 'MDM654321',
      type: 'Motor',
      make: 'Siemens',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Preventive Maintenance', description: 'Continue monitoring, next inspection in 30 days' },
      alert: { type: 'warning', message: 'Estimated failure in 3 months', confidence: '85%' },
      sensors: {
        temperature: { label: 'Temperature', value: 80, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:25 AM' },
        vibration: { label: 'Vibration', value: 4.2, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:25 AM' },
        pressure: { label: 'Pressure', value: 2.9, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:25 AM' },
      },
    },
  ],
  'assembly-zone': [
    {
      id: 1,
      name: 'Welding Robot',
      fullName: 'Welding Robot',
      assetId: 'A234',
      image: '/images/cnc-lathe-3.png',
      issue: 'Calibration drift detected',
      status: 'Online',
      riskLevel: 'Critical',
      riskColor: '#EF4444',
      priority: 'High',
      location: {
        full: 'Workspace East > Zone 22 > Assembly Zone',
        workspace: 'Workspace East',
        zone: 'Zone 22',
        area: 'Assembly Zone',
      },
      healthScore: 55,
      rul: { label: 'Remaining Useful Life', value: '1 Year 2 Months' },
      rulColor: '#EF4444',
      failuresLastMonth: 4,
      lastChecked: '3 mins ago',
      supervisor: 'John Smith',
      technician: 'Lisa Cruise',
      confidence: 92,
      rulPercentage: 55,
      zone: 'assembly-zone',
      failurePrediction: '78% failure probability',
      failureProbability: 78,
      failureTimeframe: 'within 10 days',
      workOrders: { label: 'Open Work Orders', value: 3 },
      workOrderId: 'WO-1340',
      nextService: { label: 'Next Scheduled Service', value: '22 Feb 2026' },
      model: 'WR-2200X',
      type: 'Robotic Arm',
      make: 'FANUC',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Emergency Maintenance', description: 'Recalibrate robot arm to prevent assembly defects' },
      alert: { type: 'error', message: 'Calibration drift detected', confidence: '92%' },
      sensors: {
        temperature: { label: 'Temperature', value: 72, unit: '°C', normal: '20-65', normalRange: '20-65', reportedTimestamp: 'Feb 19, 2026, 10:30 AM' },
        vibration: { label: 'Vibration', value: 5.8, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:30 AM' },
        pressure: { label: 'Pressure', value: 3.1, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:30 AM' },
      },
    },
    {
      id: 2,
      name: 'Torque Station',
      fullName: 'Torque Station',
      assetId: 'A235',
      image: '/images/cnc-lathe-2.png',
      issue: '15% torque variance detected',
      status: 'Online',
      riskLevel: 'Medium',
      riskColor: '#F59E0B',
      priority: 'Moderate',
      location: {
        full: 'Workspace East > Zone 22 > Assembly Zone',
        workspace: 'Workspace East',
        zone: 'Zone 22',
        area: 'Assembly Zone',
      },
      healthScore: 76,
      rul: { label: 'Remaining Useful Life', value: '2 Years 1 Month' },
      rulColor: '#F59E0B',
      failuresLastMonth: 1,
      lastChecked: '6 mins ago',
      supervisor: 'Sarah Johnson',
      technician: 'Emma Wilson',
      confidence: 88,
      rulPercentage: 76,
      zone: 'assembly-zone',
      failurePrediction: '35% failure probability',
      failureProbability: 35,
      failureTimeframe: 'within 30 days',
      workOrders: { label: 'Open Work Orders', value: 1 },
      workOrderId: 'WO-1341',
      nextService: { label: 'Next Scheduled Service', value: '10 Mar 2026' },
      model: 'TS-500Pro',
      type: 'Torque System',
      make: 'Atlas Copco',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Scheduled Maintenance', description: 'Replace torque sensor within 1 week' },
      alert: { type: 'warning', message: '15% torque variance detected', confidence: '88%' },
      sensors: {
        temperature: { label: 'Temperature', value: 52, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:27 AM' },
        vibration: { label: 'Vibration', value: 2.1, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:27 AM' },
        pressure: { label: 'Pressure', value: 2.7, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:27 AM' },
      },
    },
    {
      id: 3,
      name: 'Assembly Conveyor',
      fullName: 'Assembly Conveyor',
      assetId: 'A236',
      image: '/images/cnc-lathe-1.png',
      issue: 'Belt tension decreasing',
      status: 'Online',
      riskLevel: 'Low',
      riskColor: '#399432',
      priority: 'Low',
      location: {
        full: 'Workspace East > Zone 22 > Assembly Zone',
        workspace: 'Workspace East',
        zone: 'Zone 22',
        area: 'Assembly Zone',
      },
      healthScore: 82,
      rul: { label: 'Remaining Useful Life', value: '3 Years 2 Months' },
      rulColor: '#399432',
      failuresLastMonth: 0,
      lastChecked: '12 mins ago',
      supervisor: 'Mike Chen',
      technician: 'David Lee',
      confidence: 75,
      rulPercentage: 82,
      zone: 'assembly-zone',
      failurePrediction: '18% failure probability',
      failureProbability: 18,
      failureTimeframe: 'within 60 days',
      workOrders: { label: 'Open Work Orders', value: 1 },
      workOrderId: 'WO-1342',
      nextService: { label: 'Next Scheduled Service', value: '15 Apr 2026' },
      model: 'AC-3000',
      type: 'Conveyor',
      make: 'Hytrol',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Preventive Maintenance', description: 'Order replacement belt and schedule downtime' },
      alert: { type: 'warning', message: 'Belt tension decreasing', confidence: '75%' },
      sensors: {
        temperature: { label: 'Temperature', value: 45, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:20 AM' },
        vibration: { label: 'Vibration', value: 1.8, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:20 AM' },
        pressure: { label: 'Pressure', value: 2.9, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:20 AM' },
      },
    },
  ],
  'packaging-zone': [
    {
      id: 1,
      name: 'Heat Sealer',
      fullName: 'Heat Sealer',
      assetId: 'A237',
      image: '/images/cnc-lathe-1.png',
      issue: 'Overheating detected - 15°C above normal',
      status: 'Online',
      riskLevel: 'Critical',
      riskColor: '#EF4444',
      priority: 'High',
      location: {
        full: 'Workspace East > Zone 15 > Packaging Zone',
        workspace: 'Workspace East',
        zone: 'Zone 15',
        area: 'Packaging Zone',
      },
      healthScore: 48,
      rul: { label: 'Remaining Useful Life', value: '1 Year 1 Month' },
      rulColor: '#EF4444',
      failuresLastMonth: 5,
      lastChecked: '1 min ago',
      supervisor: 'John Smith',
      technician: 'Brad Sitt',
      confidence: 95,
      rulPercentage: 48,
      zone: 'packaging-zone',
      failurePrediction: '92% failure probability',
      failureProbability: 92,
      failureTimeframe: 'within 5 days',
      workOrders: { label: 'Open Work Orders', value: 4 },
      workOrderId: 'WO-1352',
      nextService: { label: 'Next Scheduled Service', value: '20 Feb 2026' },
      model: 'HS-800',
      type: 'Sealing Unit',
      make: 'Bosch Packaging',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Emergency Maintenance', description: 'Shut down and inspect heating element immediately' },
      alert: { type: 'error', message: 'Overheating detected - 15°C above normal', confidence: '95%' },
      sensors: {
        temperature: { label: 'Temperature', value: 105, unit: '°C', normal: '60-90', normalRange: '60-90', reportedTimestamp: 'Feb 19, 2026, 10:35 AM' },
        vibration: { label: 'Vibration', value: 3.5, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:35 AM' },
        pressure: { label: 'Pressure', value: 3.4, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:35 AM' },
      },
    },
    {
      id: 2,
      name: 'Label Printer',
      fullName: 'Label Printer',
      assetId: 'A238',
      image: '/images/cnc-lathe-3.png',
      issue: '8% label misalignment in last batch',
      status: 'Online',
      riskLevel: 'Medium',
      riskColor: '#F59E0B',
      priority: 'Moderate',
      location: {
        full: 'Workspace East > Zone 15 > Packaging Zone',
        workspace: 'Workspace East',
        zone: 'Zone 15',
        area: 'Packaging Zone',
      },
      healthScore: 69,
      rul: { label: 'Remaining Useful Life', value: '1 Year 8 Months' },
      rulColor: '#F59E0B',
      failuresLastMonth: 2,
      lastChecked: '10 mins ago',
      supervisor: 'Sarah Johnson',
      technician: 'Lisa Cruise',
      confidence: 82,
      rulPercentage: 69,
      zone: 'packaging-zone',
      failurePrediction: '40% failure probability',
      failureProbability: 40,
      failureTimeframe: 'within 20 days',
      workOrders: { label: 'Open Work Orders', value: 2 },
      workOrderId: 'WO-1353',
      nextService: { label: 'Next Scheduled Service', value: '05 Mar 2026' },
      model: 'LP-400X',
      type: 'Printer',
      make: 'Zebra Technologies',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Scheduled Maintenance', description: 'Realign print head within 2 days' },
      alert: { type: 'warning', message: '8% label misalignment in last batch', confidence: '82%' },
      sensors: {
        temperature: { label: 'Temperature', value: 55, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:22 AM' },
        vibration: { label: 'Vibration', value: 2.5, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:22 AM' },
        pressure: { label: 'Pressure', value: 2.6, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:22 AM' },
      },
    },
    {
      id: 3,
      name: 'Palletizer',
      fullName: 'Palletizer',
      assetId: 'A239',
      image: '/images/cnc-lathe-4.png',
      issue: 'Hydraulic pressure declining gradually',
      status: 'Online',
      riskLevel: 'Medium',
      riskColor: '#F59E0B',
      priority: 'Moderate',
      location: {
        full: 'Workspace East > Zone 15 > Packaging Zone',
        workspace: 'Workspace East',
        zone: 'Zone 15',
        area: 'Packaging Zone',
      },
      healthScore: 65,
      rul: { label: 'Remaining Useful Life', value: '2 Years 5 Months' },
      rulColor: '#F59E0B',
      failuresLastMonth: 1,
      lastChecked: '15 mins ago',
      supervisor: 'Mike Chen',
      technician: 'Jane Cena',
      confidence: 78,
      rulPercentage: 65,
      zone: 'packaging-zone',
      failurePrediction: '32% failure probability',
      failureProbability: 32,
      failureTimeframe: 'within 30 days',
      workOrders: { label: 'Open Work Orders', value: 1 },
      workOrderId: 'WO-1354',
      nextService: { label: 'Next Scheduled Service', value: '18 Mar 2026' },
      model: 'PL-1200',
      type: 'Robotic Palletizer',
      make: 'KUKA',
      detailLocation: 'Workspace East',
      recommendedAction: { severity: 'Scheduled Maintenance', description: 'Schedule hydraulic seal replacement' },
      alert: { type: 'warning', message: 'Hydraulic pressure declining gradually', confidence: '78%' },
      sensors: {
        temperature: { label: 'Temperature', value: 58, unit: '°C', normal: '20-60', normalRange: '20-60', reportedTimestamp: 'Feb 19, 2026, 10:18 AM' },
        vibration: { label: 'Vibration', value: 3.8, unit: 'mm/s', normal: '0-3', normalRange: '0-3', reportedTimestamp: 'Feb 19, 2026, 10:18 AM' },
        pressure: { label: 'Pressure', value: 2.2, unit: 'bar', normal: '2.5-3.2', normalRange: '2.5-3.2', reportedTimestamp: 'Feb 19, 2026, 10:18 AM' },
      },
    },
  ],
};

// ─── Generate remaining assets for each zone ───

const generateRemainingAssets = (zoneId, startId, count) => {
  const config = zoneAssetConfig[zoneId];
  const assets = [];
  for (let i = startId; i <= count; i++) {
    const risk = riskLevels[i % 3];
    const rulMonths = risk.level === 'Critical' ? Math.floor(Math.random() * 6) + 12
      : risk.level === 'Medium' ? Math.floor(Math.random() * 12) + 18
      : Math.floor(Math.random() * 24) + 24;

    const healthScore = riskHealthMap[risk.level] + (i % 7) - 3;
    const assetName = config.names[(i - 1) % config.names.length];
    const issueText = config.issues[(i - 1) % config.issues.length];
    const confidenceVal = Math.floor(Math.random() * 36) + 65;
    const locationParts = zoneLocationMap[zoneId].split(' > ');
    const rulYears = Math.floor(rulMonths / 12);
    const rulRemMonths = rulMonths % 12;
    const rulStr = rulRemMonths === 0 ? `${rulYears} Year${rulYears > 1 ? 's' : ''}` : `${rulYears} Year${rulYears > 1 ? 's' : ''} ${rulRemMonths} Month${rulRemMonths > 1 ? 's' : ''}`;
    const workOrderCount = Math.floor(Math.random() * 6) + 1;
    const nextServiceStr = `${Math.floor(Math.random() * 28) + 1} Mar 2026`;

    assets.push({
      id: i,
      name: assetName,
      fullName: assetName,
      image: assetImages[(i - 1) % assetImages.length],
      issue: issueText,
      status: i % 5 === 0 ? 'Offline' : 'Online',
      riskLevel: risk.level,
      riskColor: risk.color,
      priority: riskPriorityMap[risk.level],
      location: {
        full: zoneLocationMap[zoneId],
        workspace: locationParts[0] || '',
        zone: locationParts[1] || '',
        area: locationParts[2] || '',
      },
      healthScore,
      rul: { label: 'Remaining Useful Life', value: rulStr },
      rulColor: risk.color,
      failuresLastMonth: Math.floor(Math.random() * 10) + 1,
      lastChecked: `${Math.floor(Math.random() * 30) + 1} mins ago`,
      supervisor: supervisors[(i - 1) % supervisors.length],
      technician: technicians[(i - 1) % technicians.length],
      confidence: confidenceVal,
      rulPercentage: Math.floor(Math.random() * 36) + 65,
      zone: zoneId,
      failurePrediction: `${riskFailureProbMap[risk.level]}% failure probability`,
      failureProbability: riskFailureProbMap[risk.level],
      failureTimeframe: riskTimeframeMap[risk.level],
      workOrders: { label: 'Open Work Orders', value: workOrderCount },
      workOrderId: `WO-${zoneId.charAt(0).toUpperCase()}${String(i).padStart(4, '0')}`,
      nextService: { label: 'Next Scheduled Service', value: nextServiceStr },
      model: `MDL-${zoneId.charAt(0).toUpperCase()}${i}`,
      type: types[(i - 1) % types.length],
      make: makes[(i - 1) % makes.length],
      detailLocation: locationParts[0],
      recommendedAction: riskSeverityMap[risk.level],
      alert: {
        type: risk.level === 'Critical' ? 'error' : 'warning',
        message: issueText,
        confidence: `${confidenceVal}%`,
      },
      sensors: {
        temperature: {
          label: 'Temperature',
          value: risk.level === 'Critical' ? 85 + (i % 15) : risk.level === 'Medium' ? 65 + (i % 10) : 40 + (i % 15),
          unit: '\u00B0C',
          normal: '20-60',
          normalRange: '20-60',
        },
        vibration: {
          label: 'Vibration',
          value: risk.level === 'Critical' ? 5.5 + (i % 3) : risk.level === 'Medium' ? 3.5 + (i % 2) : 1.5 + (i % 2) * 0.5,
          unit: 'mm/s',
          normal: '0-3',
          normalRange: '0-3',
        },
        pressure: {
          label: 'Pressure',
          value: +(2.5 + (i % 8) * 0.1).toFixed(1),
          unit: 'bar',
          normal: '2.5-3.2',
          normalRange: '2.5-3.2',
        },
      },
    });
  }
  return assets;
};

// Pre-generate assets for each zone (primary + generated)
const assetsByZone = {
  'finishing-zone': [
    ...primaryAssetsByZone['finishing-zone'],
    ...generateRemainingAssets('finishing-zone', 4, 32),
  ],
  'assembly-zone': [
    ...primaryAssetsByZone['assembly-zone'],
    ...generateRemainingAssets('assembly-zone', 4, 28),
  ],
  'packaging-zone': [
    ...primaryAssetsByZone['packaging-zone'],
    ...generateRemainingAssets('packaging-zone', 4, 24),
  ],
};

export const getAssetsByZone = (zoneId) =>
  assetsByZone[zoneId] || assetsByZone['finishing-zone'];

// Backward-compatible: default to finishing zone
export const allAssets = assetsByZone['finishing-zone'];

export const criticalityOptions = ['All Criticalities', 'Critical', 'Medium', 'Low'];
export const supervisorOptions = ['All Supervisors', ...supervisors];
export const technicianOptions = ['All Technicians', ...technicians];
